module.exports = __webpack_public_path__ + "img/video_send_gift.17dbee0f.png";